import { cn } from "@omni/utils/styles";

type SwiperNavButtonProps = {
    icon: string;
    disabled: boolean;
    onClick?: any;
    className?: any;
    innerRef?: any;
};

const SwiperNavButton = ({
    icon,
    disabled,
    onClick,
    className,
    innerRef
}: SwiperNavButtonProps) => (
    <div
        className={cn(
            "tw:text-primary tw:cursor-pointer tw:text-3xl",
            { "tw:cursor-default tw:opacity-20 tw:text-primary": disabled },
            className
        )}
        ref={innerRef}
        onClick={() => onClick?.()}
    >
        <i className={cn(`las la-angle-${icon}`)} />
    </div>
);

export { SwiperNavButton };
